<div class="modal_dialog print-barcode-modal">
    <div class="modal_header">
        <h2>{{ 'PrintBarcode' | translate }}</h2>
        <button class="btnn close_icon" type="button" (click)="onCancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="modal_body">
        <!-- Product Information -->
        <div class="product-info">
            <h3>{{ data.productName }}</h3>
            <div class="shelf-details">
                <div class="detail-row">
                    <span class="label">{{ 'Shelf' | translate }}:</span>
                    <span class="value">{{ data.shelf.shelve }}</span>
                </div>
                <div class="detail-row">
                    <span class="label">{{ 'Zone' | translate }}:</span>
                    <span class="value">{{ data.shelf.zoneAbbreviation }}</span>
                </div>
                <div class="detail-row">
                    <span class="label">{{ 'Level' | translate }}:</span>
                    <span class="value">{{ data.shelf.levelName }}</span>
                </div>
                <div class="detail-row">
                    <span class="label">{{ 'Allocated Quantity' | translate }}:</span>
                    <span class="value">{{ data.shelf.allocatedQuantity }}</span>
                </div>
            </div>
        </div>

        <!-- Barcode Items -->
        <div class="barcode-items">
            <h4>{{ 'ItemsToPrint' | translate }}</h4>
            <div class="items-list">
                <div class="barcode-item" *ngFor="let item of getBarcodeItems(); let i = index">
                    <div class="item-info">
                        <div class="item-header">
                            <span class="item-number">{{ 'Product' | translate }} {{ i + 1 }}</span>
                            <div class="quantity-section">
                                <span class="quantity-badge" *ngIf="!isEditing(item)">
                                    {{ 'Quantity' | translate }}: {{ item.quantity }}
                                    <button 
                                        mat-icon-button
                                        class="edit-btn" 
                                        (click)="startEdit(item)"
                                        [title]="'EditQuantity' | translate">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </span>
                                
                            </div>
                        </div>
                        <div class="item-details">
                            <div class="detail-row">
                                <span class="label">{{ 'ShelfCode' | translate }}:</span>
                                <span class="value">{{ item.shelfCode }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">{{ 'SerialNumber' | translate }}:</span>
                                <span class="value">{{ item.serialNumber }}</span>
                            </div>
                        </div>
                        <div class="quantity-edit" *ngIf="isEditing(item)">
                            <div class="quantity-input-container">
                                <button type="button" class="quantity-btn decrease"
                                    (click)="decreaseQuantity()"
                                    [disabled]="(editingItem!.quantity || 0) <= 0">
                                    <mat-icon>remove</mat-icon>
                                </button>
                                <input type="number" 
                                    [(ngModel)]="editingItem!.quantity"
                                    (keydown)="onQuantityKeyDown($event)"
                                    min="0"
                                    [max]="originalQuantities[item.serialNumber]"
                                    placeholder="0" 
                                    class="quantity-input">
                                <button type="button" class="quantity-btn increase"
                                    (click)="increaseQuantity()">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                            <input type="text" [(ngModel)]="editingItem!.reason" [placeholder]="'Reason' | translate">
                            <div class="edit-actions">
                                <button 
                                    mat-icon-button 
                                    class="save-btn" 
                                    (click)="submitQuantityUpdate()"
                                    [title]="'SaveQuantity' | translate">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button 
                                    mat-icon-button 
                                    class="cancel-btn" 
                                    (click)="cancelEdit()"
                                    [title]="'CancelEdit' | translate">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="item-actions">
                        <div class="action-buttons">
                            <button 
                                mat-raised-button 
                                class="print-btn" 
                                (click)="onPrint(item)">
                                <mat-icon>print</mat-icon>
                                <span>{{ 'Print' | translate }}</span>
                            </button>
                            <button 
                                mat-raised-button 
                                class="copy-btn" 
                                (click)="copyToClipboard(item.serialNumber)"
                                [title]="'CopySerialNumberToClipboard' | translate">
                                <mat-icon>content_copy</mat-icon>
                                <span>{{ 'Copy' | translate }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal_footer">
        <button 
            mat-button 
            class="cancel-btn" 
            (click)="onCancel()">
            {{ 'Cancel' | translate }}
        </button>
        <!-- <button 
            mat-button 
            class="primary-btn" 
            (click)="onPrintAll()">
            {{ 'PrintAll' | translate }}
        </button> -->
    </div>
</div> 